import { ITheme } from './themes.interface';

export const colorThemes: ITheme[] = [
  {
    name: 'Carbon Mint',
    colors: {
      background: '#101418',
      surface: '#171D22',
      muted: '#202A30',
      accent: '#67D98F',
      accentRgbCode: '103, 217, 143',
      text: '#F3F7F4',
      textMuted: '#9FB2A8',
      border: '#2A343A',
    },
  },
  {
    name: 'Graphite Cyan',
    colors: {
      background: '#111827',
      surface: '#1F2937',
      muted: '#273549',
      accent: '#38BDF8',
      accentRgbCode: '56, 189, 248',
      text: '#F8FAFC',
      textMuted: '#A8B3C7',
      border: '#344155',
    },
  },
  {
    name: 'Blue Dusk',
    aliases: ['Muted Blue'],
    colors: {
      background: '#2B4B66',
      surface: '#172838',
      muted: '#2A4358',
      accent: '#7EA4C5',
      accentRgbCode: '126, 164, 197',
      text: '#EEF5F9',
      textMuted: '#A9B8C5',
      border: '#38556C',
    },
  },
];

export const defaultColorTheme: ITheme = colorThemes[0];
